import React, { useEffect, useRef, useState } from 'react'
import Tippy from '@tippyjs/react'
import { connect } from 'react-redux'
import {
  getCordingFabrics,
  getFabrics,
  setColorApiFilters,
  setCordingFilters,
  setFilteredFabrics,
  setFilters,
  setFrontendFilters,
  setIsOneCustomAttributeAPIFilterApplied,
  setStockApiFilters,
} from '../../actions/fabricsActions.js'
import { APP_URL } from '../../utils/config.js'
import { withRoutingTracker } from '../../HOC/withRoutingTracker.js'
import _ from 'lodash'
import { capitalizeWord, filterFabrics, sendGtag } from '../../utils/utils.js'
import OutsideClickHandler from '../../HOC/outsideClickHandler.js'
import { getUser } from '../../actions/userActions.js'

const Filters = (props) => {
  const { fabrics: fabricsObj, params, dispatch, general } = props
  const { user } = general
  const {
    brands,
    materials,
    patterns,
    uses,
    filters: styleFilters,
    cordingFilters,
    frontendFilters,
    frontendCordingFilters,
    fabrics,
    colorMap,
    colorApiFilters,
    filteredFabrics,
  } = fabricsObj
  const filters = params.style ? cordingFilters : styleFilters
  const [isMobileLayout, setIsMobileLayout] = useState(false)
  const [searchValue, setSearchValue] = useState(
    filters.find((filter) => filter.name === 'search')?.value.replace(/\[|\]/g, '') || '',
  )
  const [searchAttributes, setSearchAttributes] = useState([])
  const colorDropdown = useRef()
  const colorDropdownMenu = useRef()
  const allBrandsDropdown = useRef()
  const allBrandsDropdownMenu = useRef()
  const allMaterialsDropdown = useRef()
  const allMaterialsDropdownMenu = useRef()
  const selectUseDropdown = useRef()
  const selectUseDropdownMenu = useRef()
  const allPatternsDropdown = useRef()
  const allPatternsDropdownMenu = useRef()
  const mostPopularDropdown = useRef()
  const mostPopularDropdownMenu = useRef()

  useEffect(() => {
    checkForMobileLayout()
  }, [isMobileLayout])

  useEffect(() => {
    if (isMobileLayout) {
      _onSearch()
    }
  }, [searchValue])

  const checkForMobileLayout = _.debounce(() => {
    if (window.outerWidth <= 1024) {
      setIsMobileLayout(true)
    } else {
      setIsMobileLayout(false)
    }
  }, 100)

  useEffect(() => {
    const { dispatch } = props
    const checkParams1 = [
      { name: 'per_page', value: '100' },
      { name: 'page', value: '1' },
    ]
    const checkParams2 = [
      { name: 'per_page', value: '100' },
      { name: 'page', value: '1' },
      { name: 'stock_status', value: 'onbackorder' },
    ]
    if (isSame(filters, checkParams1) || isSame(filters, checkParams2)) {
      dispatch(setStockApiFilters(true))
    } else if (filteredFabrics.length > 99) {
      dispatch(setStockApiFilters(true))
    } else {
      dispatch(setStockApiFilters(false))
    }

    updateSearch(brandOptions, 'brand')
    updateSearch(materialOptions, 'material')
    updateSearch(useOptions, 'use')
    updateSearch(patternOptions, 'pattern')
    updateSearch(colorOptions, 'colors')
  }, [filters, frontendFilters, filteredFabrics])

  const updateSearch = (options, attribute) => {
    options.forEach((option) => {
      if (
        option.label === 'All ' ||
        option.label === 'All Uses' ||
        option.label === 'All Materials' ||
        option.label === 'All Patterns'
      ) {
        return
      }

      if (
        frontendFilters[attribute].includes(option.value) &&
        !searchAttributes.some((searchAttribute) => searchAttribute.value === option.label)
      ) {
        setSearchAttributes((prevSearchAttributes) => [
          ...prevSearchAttributes,
          {
            attribute,
            value: option.label,
          },
        ])
      }
    })
  }

  const isSame = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return false
    }
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i].name !== arr2[i].name || arr1[i].value !== arr2[i].value) {
        return false
      }
    }
    return true
  }

  const DEFAULT_OPTIONS = {
    STOCK: { label: 'All Fabrics', value: 0 },
    PRICE: { label: 'All Prices', value: 0 },
    PATTERN: { label: 'All Patterns', value: 0 },
    BRAND: { label: 'All ', value: 0 },
    MATERIAL: { label: 'All Materials', value: 0 },
    USE: { label: 'All Uses', value: 0 },
  }

  // define local state of selects
  // todo maybe add default color
  const [localSelectedColors, setLocalSelectedColors] = useState([])
  const [localSelectedBrands, setLocalSelectedBrands] = useState([DEFAULT_OPTIONS.BRAND])
  const [localSelectedMaterials, setLocalSelectedMaterials] = useState([DEFAULT_OPTIONS.MATERIAL])
  const [localSelectedUse, setLocalSelectedUse] = useState([DEFAULT_OPTIONS.USE])
  const [localSelectedPatterns, setLocalSelectedPatterns] = useState([DEFAULT_OPTIONS.PATTERN])

  const stockOptions = [
    DEFAULT_OPTIONS.STOCK,
    { label: 'In Stock', value: 'instock' },
    { label: 'Out of Stock', value: 'onbackorder' },
  ]

  if (user) {
    if (user.user_name?.toLowerCase().includes('westchase')) {
      stockOptions?.push({
        label: 'Westchase',
        value: 'westchase',
      })
    }
  }

  const brandOptions = [DEFAULT_OPTIONS.BRAND]
  const materialOptions = [DEFAULT_OPTIONS.MATERIAL]
  const patternOptions = [DEFAULT_OPTIONS.PATTERN]

  const sortByOptions = [
    { label: 'Most Popular', value: 'menu_order', order: 'asc' },
    { label: 'Newest', value: 'id', order: 'desc' },
    { label: 'Price (highest to lowest)', value: 'price-desc', order: 'desc' },
    { label: 'Price (lowest to highest)', value: 'price-asc', order: 'asc' },
    { label: 'Fabric Name (A-Z)', value: 'title', order: 'asc' },
  ]

  const useOptions = [
    ...uses.map((use) => ({
      label: use.name,
      value: use.id,
      terms: [use.id],
    })),
  ]

  useOptions.unshift(DEFAULT_OPTIONS.USE)

  const colorOptions = Object.keys(colorMap).map((colorKey) => ({
    id: colorKey,
    label: colorKey,
    value: colorKey,
    search_by: colorMap[colorKey]?.search_by,
    count: colorMap[colorKey]?.count,
  }))

  brandOptions.push(
    ...brands.map((brand) => ({
      label: brand.name,
      value: brand.id,
      terms: brand.id,
    })),
  )

  brandOptions.sort((a, b) => {
    if (a.label < b.label) {
      return -1
    }
    if (a.label > b.label) {
      return 1
    }
    return 0
  })

  materialOptions.push(
    ...materials.map((material) => ({
      label: material.name,
      value: material.terms.join(','),
      terms: material.terms.join(','),
    })),
  )

  materialOptions.sort((a, b) => {
    if (a.label < b.label) {
      return -1
    }
    if (a.label > b.label) {
      return 1
    }
    return 0
  })

  materialOptions.unshift(
    materialOptions.splice(
      materialOptions.findIndex((material) => material.value === 0),
      1,
    )[0],
  )

  patternOptions.push(
    ...patterns.map((pattern) => ({
      label: pattern.name?.replace(/&amp;/g, '&'),
      value: pattern.id,
      terms: [pattern.id],
    })),
  )

  const newPatternOptions = patternOptions.filter((option) => option.label.length > 1)

  const _getIsAnyColorSelected = () => {
    const { params } = props
    if (params.style) {
      return colorApiFilters.length || frontendCordingFilters.colors?.length
    } else {
      return colorApiFilters.length || frontendFilters.colors?.length
    }
  }

  const _getExistingColors = () => {
    const { params } = props
    if (params.style) {
      return colorApiFilters.length ? colorApiFilters : frontendCordingFilters.colors
    } else {
      return colorApiFilters.length ? colorApiFilters : frontendFilters.colors
    }
  }

  const _getIsAnyFabricSelected = () => {
    const { params } = props
    if (params.style) {
      return stockOptions.find(
        (option) =>
          option.value === cordingFilters.find((filter) => filter.name === 'stock_status')?.value,
      )
    } else {
      return stockOptions.find(
        (option) =>
          option.value === filters.find((filter) => filter.name === 'stock_status')?.value,
      )
    }
  }

  const _getIsAnyPriceSelected = () => {
    const { params } = props
    if (params.style) {
      if (
        cordingFilters.find((filter) => filter.name === 'max_price') &&
        cordingFilters.find((filter) => filter.name === 'min_price')
      ) {
        return { label: '$$', value: 2 }
      } else if (
        cordingFilters.find((filter) => filter.name === 'max_price' && filter.name !== 'min_price')
      ) {
        return { label: '$', value: 1 }
      } else if (
        cordingFilters.find((filter) => filter.name === 'min_price' && filter.name !== 'max_price')
      ) {
        return { label: '$$$', value: 3 }
      } else {
        return { label: 'All Prices', value: 0 }
      }
    } else {
      if (
        filters.find((filter) => filter.name === 'max_price') &&
        filters.find((filter) => filter.name === 'min_price')
      ) {
        return { label: '$$', value: 2 }
      } else if (
        filters.find((filter) => filter.name === 'max_price' && filter.name !== 'min_price')
      ) {
        return { label: '$', value: 1 }
      } else if (
        filters.find((filter) => filter.name !== 'max_price' && filter.name === 'min_price')
      ) {
        return { label: '$$$', value: 3 }
      } else {
        return { label: 'All Prices', value: 0 }
      }
    }
  }

  const _getIsAnyBrandSelected = () => {
    return (
      brandOptions.find(
        (option) => option.value === filters.find((filter) => filter.value === option.value)?.value,
      ) || brandOptions.find((option) => option.value === frontendFilters?.brand)
    )
  }

  const _getIsAnyMaterialSelected = () => {
    const matchingMaterials = materialOptions.filter(
      (option) => option.value === filters.find((filter) => filter.value === option.value)?.value,
    )
    return matchingMaterials?.length
      ? matchingMaterials
      : materialOptions.filter((option) => option.value === frontendFilters?.material)
  }

  const _getIsAnyUseSelected = () => {
    return (
      useOptions.find(
        (option) => option.value === filters.find((filter) => filter.value === option.value)?.value,
      ) || useOptions.find((option) => option.value === frontendFilters?.use)
    )
  }

  const _getIsAnyPatternSelected = () => {
    return (
      newPatternOptions.find(
        (option) => option.value === filters.find((filter) => filter.value === option.value)?.value,
      ) || newPatternOptions.find((option) => option.value === frontendFilters?.pattern)
    )
  }

  const _getIsAnySortBySelected = () => {
    if (
      sortByOptions.find(
        (option) =>
          option.value ===
          filters.find((filter) => filter.value === option.value && filter.name === 'orderby')
            ?.value,
      )
    ) {
      return sortByOptions.find(
        (option) =>
          option.value ===
          filters.find((filter) => filter.value === option.value && filter.name === 'orderby')
            ?.value,
      )
    } else if (
      sortByOptions.find(
        (option) =>
          option.value ===
          filters.find(
            (filter) => filter.checkboxValue === option.value && filter.name === 'orderby',
          )?.checkboxValue,
      )
    ) {
      return sortByOptions.find(
        (option) =>
          option.value ===
          filters.find(
            (filter) => filter.checkboxValue === option.value && filter.name === 'orderby',
          )?.checkboxValue,
      )
    }
    return sortByOptions.find(
      (option) => option.value === filters.find((filter) => filter.value === option.value)?.value,
    )
  }

  const handleFetchFabrics = (filterParams) => {
    const { dispatch, params } = props

    if (isMobileLayout) {
      if (params.style) {
        dispatch(setCordingFilters(filterParams))
      } else {
        dispatch(setFilters(filterParams))
      }
    } else {
      if (params.style) {
        dispatch(getCordingFabrics(filterParams))
      } else {
        dispatch(getFabrics(filterParams))
      }
    }
  }

  const _onSortByChange = (option) => {
    const { params: propsParams } = props
    let params = [...filters]

    if (propsParams.style) {
      sendGtag('sort_by_filter_style', option?.label)
    }
    else {
      sendGtag('sort_by_filter_fabrics', option?.label)
    }

    const doesOrderByExist = params.find(
      (param) => param.name === 'orderby' && param.value === option.value.split('-')[0],
    )
    const doesOrderExist = params.find(
      (param) => param.name === 'order' && param.value === option.order,
    )
    params = params.filter((param) => !['orderby', 'order'].includes(param.name))

    if (!(doesOrderByExist && doesOrderExist)) {
      if (propsParams.style) {
        params.push(
          {
            name: 'orderby',
            value: option.value?.toString().split('-')[0],
            checkboxValue: option.value,
          },
          {
            name: 'order',
            value: option.order,
          },
          {
            name: 'cording_in_stock',
            value: '1',
          },
        )
      } else {
        params.push(
          {
            name: 'orderby',
            value: option.value?.toString().split('-')[0],
            checkboxValue: option.value,
          },
          {
            name: 'order',
            value: option.order,
          },
        )
      }
    }

    handleFetchFabrics(params)
  }

  const _getNewSelectedOptions = (option, localSelectedOptions, defaultOption) => {
    const isOptionSelected = localSelectedOptions.find(
      (selectedOption) => selectedOption.value === option.value,
    )
    let newSelectedOptions = []

    if (isOptionSelected) {
      newSelectedOptions = localSelectedOptions.filter(
        (materialOption) => materialOption.value !== option.value,
      )

      if (newSelectedOptions.length === 0) {
        newSelectedOptions.push(defaultOption)
      }
    } else {
      if (option.value === defaultOption.value) {
        newSelectedOptions.push(option)
      } else {
        newSelectedOptions = [
          option,
          ...localSelectedOptions.filter(
            (materialOption) => materialOption.value !== defaultOption.value,
          ),
        ]
      }
    }

    return newSelectedOptions
  }

  const _updateSelectedOptions = (newSelectedOptions, setLocalSelectedOptions) => {
    setLocalSelectedOptions(newSelectedOptions)
  }

  const _getFilterFromOption = (attributeSlug, newSelectedOptions, defaultOption) => {
    if (newSelectedOptions.length === 1 && newSelectedOptions[0].value === defaultOption.value) {
      return defaultOption
    }

    const newSelectedOptionsValues = newSelectedOptions.map((option) => option.value)

    const filter = {
      name: attributeSlug,
      value: newSelectedOptionsValues,
    }

    return filter
  }

  const _onMultipleOptionFilterChange =
    (
      attributeSlug,
      option,
      localSelectedOptions,
      setLocalSelectedOptions,
      defaultOption,
      cutomGetFilterFromOption = null,
    ) =>
    () => {
      const { params } = props
      const newSelectedOptions = _getNewSelectedOptions(option, localSelectedOptions, defaultOption)
      const appliedOptions = newSelectedOptions?.sort()?.map(option => option.label).join(',')
      let stepType = ''

      if (params.style) {
        stepType = 'style'
      }
      else {
        stepType = 'fabrics'
      }

      switch (attributeSlug) {
        case 'pa_colors':
          sendGtag(`color_filter_${stepType}`, appliedOptions)
          break
        case 'pa_brand':
          sendGtag(`brands_filter_${stepType}`, appliedOptions)
          break
        case 'pa_material':
          sendGtag(`materials_filter_${stepType}`, appliedOptions)
          break
        case 'pa_use':
          sendGtag(`use_filter_${stepType}`, appliedOptions)
          break
        case 'pa_pattern':
          sendGtag(`patterns_filter_${stepType}`, appliedOptions)
          break
        default:
          break
      }

      _updateSelectedOptions(newSelectedOptions, setLocalSelectedOptions)
      const getFilterFromOption = cutomGetFilterFromOption || _getFilterFromOption
      const filter = getFilterFromOption(attributeSlug, newSelectedOptions, defaultOption)
      _onAttributeFilterChange(attributeSlug, option, filter)()
    }

  const _onAttributeFilterChange = (attributeSlug, option) => () => {
    const { dispatch } = props
    let params = [...filters]
    const attribute = attributeSlug.split('_')[1]
    const attributeReplacement = `search_${attribute}`
    let newFrontendFilters = { ...frontendFilters }
    let newFabrics = _.cloneDeep(fabrics)

    const id = newFrontendFilters[attribute]?.indexOf(0)
    if (id > -1) {
      newFrontendFilters[attribute].splice(id, 1)
    }

    //if there are multiple options on same attribute
    newFrontendFilters[attribute] = newFrontendFilters[attribute]
      ? newFrontendFilters[attribute].concat(option.value)
      : option.value

    // add or remove filter option
    let searchOptions = [...searchAttributes]
    const index = searchOptions.findIndex(
      (searchAttribute) => searchAttribute.value === option.label,
    )
    let objectToUpdate = params.find((obj) => obj.name === attributeReplacement)

    // Remove a value from a filter, or the filter option completely (make is "")
    if (index > -1) {
      searchOptions.splice(index, 1)
      newFrontendFilters[attribute] = newFrontendFilters[attribute]?.filter(
        (attribute) => !String(option?.value)?.includes(attribute),
      )

      const searchAttributesForCurrentField = searchOptions.filter(
        (searchAttribute) => searchAttribute.attribute === attribute,
      )
      const filterValue =
        searchAttributesForCurrentField.length > 0
          ? searchAttributesForCurrentField
              ?.map((searchAttribute) => searchAttribute.value)
              .join(';')
          : ''

      if (!objectToUpdate) {
        objectToUpdate = {
          name: attributeReplacement,
          value: filterValue,
        }
        params.push(objectToUpdate)
      } else {
        objectToUpdate.value = filterValue
      }
    } else {
      searchOptions = [
        ...searchOptions,
        {
          attribute,
          value: option.label,
        },
      ]
      const filterValue = searchOptions
        ?.filter((searchOption) => searchOption.attribute === attribute)
        ?.map((searchAttribute) => searchAttribute.value)
        ?.join(';')

      // Add the filter
      if (!objectToUpdate) {
        objectToUpdate = {
          name: attributeReplacement,
          value: filterValue,
        }
        params.push(objectToUpdate)
      } else {
        // Append to the filter
        objectToUpdate.value = filterValue
      }
    }

    // Add default All option on deselected options
    if (!newFrontendFilters[attribute].length) {
      newFrontendFilters[attribute].push(0)
    }

    if (option.value === 0) {
      searchOptions = []
      newFrontendFilters[attribute] = [0]
    }

    setSearchAttributes(searchOptions)
    dispatch(setFrontendFilters(newFrontendFilters))

    if (!isMobileLayout) {
      newFabrics = filterFabrics(newFrontendFilters, newFabrics, fabricsObj, option.label)
      newFabrics = newFabrics.filter((fabric) => fabric)
      dispatch(setFilteredFabrics(newFabrics))
    }

    params = params.filter(
      (param) =>
        param.name !== 'search' &&
        (!param.name.includes('search_') || (param.name.includes('search_') && param.value)),
    )

    handleFetchFabrics(params)
  }

  const _onSearchInputKeyUp = (e) => {
    if (!isMobileLayout && e.key === 'Enter') {
      _onSearch()
    }
  }

  const _onSearch = () => {
    const { params: propsParams } = props
    let params
    params = [...filters]

    params = params.filter((param) => param.name !== 'search')
    const value = Object.keys(colorMap).includes(capitalizeWord(searchValue))
      ? colorMap[capitalizeWord(searchValue)].search_by
      : searchValue

    if (propsParams.style) {
      sendGtag('search_fabrics_style', value)
    }
    else {
      sendGtag('search_fabrics', value)
    }

    let filtersSearchValue

    filtersSearchValue = filters.find((filter) => filter.name === 'search')?.value

    if (!searchValue?.trim()) {
      if (!filtersSearchValue?.trim()) {
        return
      }
    } else {
      params.push({
        name: 'search',
        value: value,
      })

      if (propsParams.style && !params.find((param) => param.name === 'orderby')) {
        params.push({
          name: 'orderby',
          value: 'menu_order',
        })
      }

      if (propsParams.style && !params.find((param) => param.name === 'order')) {
        params.push({
          name: 'order',
          value: 'asc',
        })
      }
    }

    handleFetchFabrics(params)
  }

  const _onClear = () => {
    const { params: propsParams } = props
    let params
    params = [...filters]

    if (propsParams.style) {
      sendGtag('search_fabrics_style', '')
    }
    else {
      sendGtag('search_fabrics', '')
    }

    params = params.filter((param) => param.name !== 'search')
    setSearchValue('')

    handleFetchFabrics(params)
  }

  const _onFavouritesFilterChange = () => {
    const { params: propsParams } = props
    let newFrontendFilters
    const { dispatch } = props
    let params = [...filters]

    newFrontendFilters = { ...frontendFilters }
    newFrontendFilters.showOnlyFavourites = !frontendFilters.showOnlyFavourites

    if (propsParams.style) {
      sendGtag('favorites_filter_style', `Favorite Value ${newFrontendFilters.showOnlyFavourites ? 1 : 0}`)
    }
    else {
      sendGtag('favorites_filter_fabrics', `Favorite Value ${newFrontendFilters.showOnlyFavourites ? 1 : 0}`)
    }

    dispatch(setFrontendFilters(newFrontendFilters))
    let newFabrics

    if (newFrontendFilters.showOnlyFavourites === true) {
      // newFabrics = _.cloneDeep(fabricsKits); wy?
      newFabrics = _.cloneDeep(fabrics)
    } else {
      newFabrics = _.cloneDeep(fabrics)
    }

    newFabrics = filterFabrics(newFrontendFilters, newFabrics, fabricsObj)
    dispatch(setFilteredFabrics(newFabrics))

    params = params.filter(
      (param) =>
        param.name !== 'search' &&
        (!param.name.includes('search_') || (param.name.includes('search_') && param.value)),
    )

    handleFetchFabrics(params)
  }

  const _onSearchInputChange = (e) => {
    setSearchValue(e.target.value)
  }

  let isSearchValue

  isSearchValue = filters.find((filter) => filter.name === 'search')

  const [isWestchaseSelected, setIsWestchaseSelected] = useState(null)

  const selectedColorIds = []
  const selectedFabrics = []
  const selectedPrices = []
  const selectedBrand = []
  const selectedMaterials = []
  const selectedUse = []
  const selectedPatterns = []
  const selectedPopular = []

  if (_getIsAnyColorSelected()) {
    const existingColors = _getExistingColors()
    selectedColorIds.push(...existingColors)
  }

  if (_getIsAnyFabricSelected() || !_getIsAnyFabricSelected()) {
    const existingFabrics = _getIsAnyFabricSelected()
    if (!existingFabrics && !isWestchaseSelected) {
      selectedFabrics.push({ label: 'All Fabrics', value: 0 })
    } else if (!existingFabrics && isWestchaseSelected) {
      selectedFabrics.push({
        label: 'Westchase',
        value: 'westchase',
      })
    } else {
      selectedFabrics.push(existingFabrics)
    }
  }

  if (_getIsAnyPriceSelected()) {
    const existingPrices = _getIsAnyPriceSelected()
    selectedPrices.push(existingPrices)
  }

  if (_getIsAnyBrandSelected() || !_getIsAnyBrandSelected()) {
    const existingBrand = _getIsAnyBrandSelected()
    if (!existingBrand) {
      selectedBrand.push({ label: 'All Brands', value: 0 })
    } else {
      selectedBrand.push(existingBrand)
    }
  }

  if (_getIsAnyMaterialSelected() || !_getIsAnyMaterialSelected()) {
    const existingMaterial = _getIsAnyMaterialSelected()
    if (!existingMaterial) {
      selectedMaterials.push({ label: 'All Materials', value: 0 })
    } else {
      selectedMaterials.push(...existingMaterial)
    }
  }

  if (_getIsAnyUseSelected() || !_getIsAnyUseSelected()) {
    const existingUse = _getIsAnyUseSelected()
    if (!existingUse) {
      selectedUse.push({ label: 'All Uses', value: 0 })
    } else {
      selectedUse.push(existingUse)
    }
  }

  if (_getIsAnyPatternSelected() || !_getIsAnyPatternSelected()) {
    const existingPattern = _getIsAnyPatternSelected()
    if (!existingPattern) {
      selectedPatterns.push({ label: 'All Patterns', value: 0 })
    } else {
      selectedPatterns.push(existingPattern)
    }
  }

  useEffect(() => {
    dispatch(getUser())
  }, [])

  if (_getIsAnySortBySelected() || !_getIsAnySortBySelected()) {
    const existingSortBy = _getIsAnySortBySelected()
    if (!existingSortBy) {
      selectedPopular.push({ label: 'Most Popular', order: 'asc', value: 'menu_order' })
      _onSortByChange({ label: 'Most Popular', order: 'asc', value: 'menu_order' })
    } else {
      selectedPopular.push(existingSortBy)
    }
  }

  const removeFilters = () => {
    const { params: propsParams } = props
    const { dispatch } = props
    let defaultParams
    defaultParams = [
      {
        name: 'per_page',
        value: '100',
      },
      {
        name: 'page',
        value: '1',
      },
    ]
    const defaultFrontendFilters = {
      brand: [0],
      material: [0],
      use: [0],
      pattern: [0],
      colors: [0],
    }

    if (propsParams.style) {
      sendGtag('clear_filters_style')
    }
    else {
      sendGtag('clear_filters_fabrics')
    }

    setLocalSelectedColors([])
    setLocalSelectedBrands([DEFAULT_OPTIONS.BRAND])
    setLocalSelectedMaterials([DEFAULT_OPTIONS.MATERIAL])
    setLocalSelectedUse([DEFAULT_OPTIONS.USE])
    setLocalSelectedPatterns([DEFAULT_OPTIONS.PATTERN])
    setIsWestchaseSelected(null)

    dispatch(setStockApiFilters(true))
    dispatch(setColorApiFilters([]))
    dispatch(setFrontendFilters(defaultFrontendFilters))
    dispatch(setIsOneCustomAttributeAPIFilterApplied(false))
    setSearchValue('')

    handleFetchFabrics(defaultParams)
  }

  const _shouldClearFilterButtonBeDisplayed = () => {
    return (
      colorApiFilters.length > 0 ||
      frontendFilters.brand[0] !== 0 ||
      frontendFilters.material[0] !== 0 ||
      frontendFilters.use[0] !== 0 ||
      frontendFilters.pattern[0] !== 0 ||
      frontendFilters.colors[0] !== 0 ||
      filters.find((item) => item.name === 'stock_status')?.value !== undefined ||
      filters.find((item) => item.name === 'min_price')?.value ||
      filters.find((item) => item.name === 'max_price')?.value ||
      filters.find((item) => item.name === 'search')?.value ||
      (filters.find((item) => item.name === 'orderby')?.value &&
        filters.find((item) => item.name === 'orderby')?.value !== 'menu_order') ||
      (filters.find((item) => item.name === 'order')?.value &&
        filters.find((item) => item.name === 'order')?.value !== 'asc') ||
      filters.find((item) => item.name === 'attribute_term')?.value ||
      isWestchaseSelected
    )
  }

  let showOnlyFavourites
  showOnlyFavourites = frontendFilters.showOnlyFavourites

  const renderFiltersText = () => {
    return !isMobileLayout && !params.style ? (
      <p className="cushion-designer-footer-text">
        Select colors, brands, materials, and patterns below to narrow your search.
      </p>
    ) : null
  }

  const _closeColorDropdown = () => {
    colorDropdownMenu.current.className = 'dd-menu'
    colorDropdown.current.className = 'dd-button'
  }

  const _openColorDropdown = () => {
    if (
      colorDropdownMenu.current.className.includes('menu-active') &&
      colorDropdown.current.className.includes('dd-active')
    ) {
      _closeColorDropdown()
      return
    }
    colorDropdownMenu.current.className = 'dd-menu menu-active'
    colorDropdown.current.className = 'dd-button dd-active'
  }

  const _closeAllBrandsDropdown = () => {
    allBrandsDropdownMenu.current.className = 'dd-menu'
    allBrandsDropdown.current.className = 'dd-button'
  }

  const _openAllBrandsDropdown = () => {
    if (
      allBrandsDropdownMenu.current.className.includes('menu-active') &&
      allBrandsDropdown.current.className.includes('dd-active')
    ) {
      _closeAllBrandsDropdown()
      return
    }
    allBrandsDropdownMenu.current.className = 'dd-menu menu-active'
    allBrandsDropdown.current.className = 'dd-button dd-active'
  }

  const _closeAllMaterialsDropdown = () => {
    allMaterialsDropdownMenu.current.className = 'dd-menu'
    allMaterialsDropdown.current.className = 'dd-button'
  }

  const _openAllMaterialsDropdown = () => {
    if (
      allMaterialsDropdownMenu.current.className.includes('menu-active') &&
      allMaterialsDropdown.current.className.includes('dd-active')
    ) {
      _closeAllMaterialsDropdown()
      return
    }
    allMaterialsDropdownMenu.current.className = 'dd-menu menu-active'
    allMaterialsDropdown.current.className = 'dd-button dd-active'
  }

  const _closeSelectUseDropdown = () => {
    selectUseDropdownMenu.current.className = 'dd-menu'
    selectUseDropdown.current.className = 'dd-button'
  }

  const _openSelectUseDropdown = () => {
    if (
      selectUseDropdownMenu.current.className.includes('menu-active') &&
      selectUseDropdown.current.className.includes('dd-active')
    ) {
      _closeSelectUseDropdown()
      return
    }
    selectUseDropdownMenu.current.className = 'dd-menu menu-active'
    selectUseDropdown.current.className = 'dd-button dd-active'
  }

  const _closeAllPatternsDropdown = () => {
    allPatternsDropdownMenu.current.className = 'dd-menu'
    allPatternsDropdown.current.className = 'dd-button'
  }

  const _openAllPatternsDropdown = () => {
    if (
      allPatternsDropdownMenu.current.className.includes('menu-active') &&
      allPatternsDropdown.current.className.includes('dd-active')
    ) {
      _closeAllPatternsDropdown()
      return
    }
    allPatternsDropdownMenu.current.className = 'dd-menu menu-active'
    allPatternsDropdown.current.className = 'dd-button dd-active'
  }

  const _closeMostPopularDropdown = () => {
    mostPopularDropdownMenu.current.className = 'dd-menu'
    mostPopularDropdown.current.className = 'dd-button'
  }

  const _openMostPopularDropdown = () => {
    if (
      mostPopularDropdownMenu.current.className.includes('menu-active') &&
      mostPopularDropdown.current.className.includes('dd-active')
    ) {
      _closeMostPopularDropdown()
      return
    }
    mostPopularDropdownMenu.current.className = 'dd-menu menu-active'
    mostPopularDropdown.current.className = 'dd-button dd-active'
  }

  return (
    <>
      <div className={`search-header cushion-designer ${params.style ? 'style' : ''}`}>
        {renderFiltersText()}
      </div>
      <div className="filter-header">
        <div className={'reset-filters-container'}>
          <button
            id="reset-button"
            type={'button'}
            disabled={!_shouldClearFilterButtonBeDisplayed()}
            className={`clear-filters-button ${!_shouldClearFilterButtonBeDisplayed() ? 'disabled' : ''}`}
            onClick={removeFilters}
          >
            Remove Filters
          </button>
        </div>
        <div className="filters">
          <Tippy content={'Show Favorites'}>
            <div className="colors-favourites-container" onClick={_onFavouritesFilterChange}>
              <span>Favorites</span>
              <img
                id="favourites"
                alt={'favourites'}
                className={'favourite-filter'}
                src={`${APP_URL}/wp-content/uploads/2021/11/${showOnlyFavourites ? 'heart-full' : 'heart'}.svg`}
              />
            </div>
          </Tippy>
          <label
            className={`colors-dropdown ${frontendFilters.colors?.length && frontendFilters.colors[0] !== 0 ? 'filters-applied' : ''}`}
            style={{ marginRight: '10px' }}
          >
            <OutsideClickHandler onOutsideClick={_closeColorDropdown}>
              <div ref={colorDropdown} onClick={_openColorDropdown} className={'dd-button'}>
                <p>Colors</p>
              </div>
              <input type="checkbox" className={'dd-input'} />
              <div ref={colorDropdownMenu} className="dd-menu">
                {colorOptions.map((option) => (
                  <div
                    key={option.label}
                    className={`menu-list ${frontendFilters?.colors?.some((color) => option.id === color) ? 'selected' : ''}`}
                    onClick={_onMultipleOptionFilterChange(
                      'pa_colors',
                      option,
                      localSelectedColors,
                      setLocalSelectedColors,
                      {},
                    )}
                  >
                    <p>{capitalizeWord(option.label)}</p>
                    <Tippy
                      placement="right"
                      content={`${capitalizeWord(option.label)} (${option.count || 0})`}
                    >
                      <input
                        type={'checkbox'}
                        checked={frontendFilters?.colors?.some((color) => option.id === color)}
                        id={`color-option-${option.value}`}
                        className={`color ${frontendFilters?.colors?.some((color) => option.id === color) ? 'selected' : ''}`}
                      />
                    </Tippy>
                  </div>
                ))}
              </div>
            </OutsideClickHandler>
          </label>
          <label
            className={`colors-dropdown ${frontendFilters.brand?.length && frontendFilters.brand[0] !== 0 ? 'filters-applied' : ''}`}
            style={{ marginRight: '10px' }}
          >
            <OutsideClickHandler onOutsideClick={_closeAllBrandsDropdown}>
              <div ref={allBrandsDropdown} onClick={_openAllBrandsDropdown} className={'dd-button'}>
                <p>Brands</p>
              </div>
              <input type="checkbox" className={'dd-input'} />
              <div
                style={isMobileLayout ? { width: '160px' } : { width: '200px' }}
                ref={allBrandsDropdownMenu}
                className="dd-menu"
              >
                {brandOptions.map((option) => (
                  <div
                    key={option.label}
                    className={`menu-list ${frontendFilters?.brand?.some((brand) => option.value === brand) ? 'selected' : ''}`}
                    onClick={_onMultipleOptionFilterChange(
                      'pa_brand',
                      option,
                      localSelectedBrands,
                      setLocalSelectedBrands,
                      DEFAULT_OPTIONS.BRAND,
                    )}
                  >
                    <p>{capitalizeWord(option.label)}</p>
                    <input
                      type={'checkbox'}
                      checked={
                        frontendFilters?.brand?.some((brand) => option.value === brand)
                          ? true
                          : false
                      }
                      id={`color-option-${option.value}`}
                      className={`color ${frontendFilters?.brand?.some((brand) => option.value === brand) ? 'selected' : ''}`}
                    />
                  </div>
                ))}
              </div>
            </OutsideClickHandler>
          </label>
          <label
            className={`colors-dropdown ${frontendFilters.material?.length && frontendFilters.material[0] !== 0 ? 'filters-applied' : ''}`}
            style={{ marginRight: '10px' }}
          >
            <OutsideClickHandler onOutsideClick={_closeAllMaterialsDropdown}>
              <div
                ref={allMaterialsDropdown}
                onClick={_openAllMaterialsDropdown}
                className={'dd-button'}
              >
                <p>Materials</p>
              </div>
              <input type="checkbox" className={'dd-input'} />
              <div style={{ width: '160px' }} ref={allMaterialsDropdownMenu} className="dd-menu">
                {materialOptions.map((option) => (
                  <div
                    key={option.label}
                    className={`menu-list ${frontendFilters?.material?.some((material) => option.value === material) ? 'selected' : ''}`}
                    onClick={_onMultipleOptionFilterChange(
                      'pa_material',
                      option,
                      localSelectedMaterials,
                      setLocalSelectedMaterials,
                      DEFAULT_OPTIONS.MATERIAL,
                    )}
                  >
                    <p>{capitalizeWord(option.label)}</p>
                    <input
                      type={'checkbox'}
                      checked={frontendFilters?.material?.some(
                        (material) => option.value === material,
                      )}
                      id={`color-option-${option.value}`}
                      className={`color ${frontendFilters?.material?.some((material) => option.id === material) ? 'selected' : ''}`}
                    />
                  </div>
                ))}
              </div>
            </OutsideClickHandler>
          </label>
          <label
            className={`colors-dropdown ${frontendFilters.use?.length && frontendFilters.use[0] !== 0 ? 'filters-applied' : ''}`}
            style={{ marginRight: '10px' }}
          >
            <OutsideClickHandler onOutsideClick={_closeSelectUseDropdown}>
              <div ref={selectUseDropdown} onClick={_openSelectUseDropdown} className={'dd-button'}>
                <p>Use</p>
              </div>
              <input type="checkbox" className={'dd-input'} />
              <div style={{ width: '160px' }} ref={selectUseDropdownMenu} className="dd-menu">
                {useOptions.map((option) => (
                  <div
                    key={option.label}
                    className={`menu-list ${frontendFilters?.use?.some((use) => option.value === use) ? 'selected' : ''}`}
                    onClick={_onMultipleOptionFilterChange(
                      'pa_use',
                      option,
                      localSelectedUse,
                      setLocalSelectedUse,
                      DEFAULT_OPTIONS.USE,
                    )}
                  >
                    <p>{capitalizeWord(option.label)}</p>
                    <input
                      type={'checkbox'}
                      checked={frontendFilters?.use?.some((use) => option.value === use)}
                      id={`color-option-${option.value}`}
                      className={`color ${frontendFilters?.use?.some((use) => option.value === use) ? 'selected' : ''}`}
                    />
                  </div>
                ))}
              </div>
            </OutsideClickHandler>
          </label>
          <label
            className={`colors-dropdown ${frontendFilters.pattern?.length && frontendFilters.pattern[0] !== 0 ? 'filters-applied' : ''}`}
            style={{ marginRight: '10px' }}
          >
            <OutsideClickHandler onOutsideClick={_closeAllPatternsDropdown}>
              <div
                ref={allPatternsDropdown}
                onClick={_openAllPatternsDropdown}
                className={'dd-button'}
              >
                <p>Patterns</p>
              </div>
              <input type="checkbox" className={'dd-input'} />
              <div style={{ width: '200px' }} ref={allPatternsDropdownMenu} className="dd-menu">
                {newPatternOptions.map((option) => (
                  <div
                    key={option.label}
                    className={`menu-list ${frontendFilters?.pattern?.some((pattern) => option.value === pattern) ? 'selected' : ''}`}
                    onClick={_onMultipleOptionFilterChange(
                      'pa_pattern',
                      option,
                      localSelectedPatterns,
                      setLocalSelectedPatterns,
                      DEFAULT_OPTIONS.PATTERN,
                    )}
                  >
                    <p>{capitalizeWord(option.label)}</p>
                    <input
                      type={'checkbox'}
                      checked={frontendFilters?.pattern?.some(
                        (pattern) => option.value === pattern,
                      )}
                      id={`color-option-${option.value}`}
                      className={`color ${frontendFilters?.pattern?.some((pattern) => option.value === pattern) ? 'selected' : ''}`}
                    />
                  </div>
                ))}
              </div>
            </OutsideClickHandler>
          </label>
          <label
            className={`colors-dropdown ${!selectedPopular?.some((item) => item.value === 'menu_order') ? 'filters-applied' : ''}`}
            style={{ marginRight: '10px' }}
          >
            <OutsideClickHandler onOutsideClick={_closeMostPopularDropdown}>
              <div
                ref={mostPopularDropdown}
                onClick={_openMostPopularDropdown}
                className={'dd-button'}
              >
                <p>Sort By</p>
              </div>
              <input type="checkbox" className={'dd-input'} />
              <div
                style={isMobileLayout ? { width: '160px' } : { width: '200px' }}
                ref={mostPopularDropdownMenu}
                className="dd-menu"
              >
                {sortByOptions.map((option) => (
                  <div
                    key={option.label}
                    className={`menu-list ${selectedPopular.find((material) => material.value === option.value) ? 'selected' : ''}`}
                    onClick={() => _onSortByChange(option)}
                  >
                    <p>{capitalizeWord(option.label)}</p>
                    <input
                      type={'checkbox'}
                      checked={selectedPopular.some((material) => material.value === option.value)}
                      id={`color-option-${option.value}`}
                      className={`color ${selectedPopular.some((material) => material.value === option.value) ? 'selected' : ''}`}
                    />
                  </div>
                ))}
              </div>
            </OutsideClickHandler>
          </label>
          <div className="input-container">
            <input
              id="search-input"
              className="search-input"
              type={'text'}
              placeholder="Search"
              onKeyUp={_onSearchInputKeyUp}
              onChange={_onSearchInputChange}
              value={searchValue}
            />
            <img
              id="search-icon"
              src={`${APP_URL}/wp-content/uploads/2021/10/${isSearchValue ? 'delete' : 'search'}.png`}
              className={`${isSearchValue ? 'delete-icon' : 'search-icon'}`}
              onClick={isSearchValue ? _onClear : _onSearch}
            />
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  general: state.general,
  fabrics: state.fabrics,
})

export default withRoutingTracker(connect(mapStateToProps)(Filters))
